import { render, staticRenderFns } from "./UserRecentCall.vue?vue&type=template&id=233ae602&scoped=true&"
import script from "./UserRecentCall.vue?vue&type=script&lang=js&"
export * from "./UserRecentCall.vue?vue&type=script&lang=js&"
import style0 from "./UserRecentCall.vue?vue&type=style&index=0&id=233ae602&prod&lang=scss&"
import style1 from "./UserRecentCall.vue?vue&type=style&index=1&id=233ae602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ae602",
  null
  
)

export default component.exports